import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from '@ov-suite/authguard-angular';
import { FeaturesConfig } from './features.config';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            m => m.DashboardModule
          )
      },
      {
        data: { feature: { id: FeaturesConfig.ViewProfile }, },
        path: 'user',
        loadChildren: () =>
          import('./modules/user/user.module').then(m => m.UserModule)
      },
      {
        data: { feature: { id: FeaturesConfig.ManageUsers }, },
        path: 'management/users',
        loadChildren: () =>
          import('./modules/users/users.module').then(m => m.UsersModule)
      },
      {
        data: { feature: { id: FeaturesConfig.ManageUsers }, },
        path: 'management/user-type',
        loadChildren: () =>
          import('./modules/user-type/user-type.module').then(
            m => m.UserTypeModule
          )
      }
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () =>
          import('./pages/pages.module').then(m => m.PagesModule)
      },
      {
        path: '**',
        component: AuthLayoutComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
